import { graphqlCall } from '@pella/fetch-client';
import { GET_EBS_ORGANIZATIONS } from './ebs.graphql.js';

const GRAPHQL_URL = `${window.REACT_APP_API_URL}/ebs-api/graphql`;

/**
 * Fetch the organizations from EBS.
 * @returns {Promise<Pella.EbsAPI.Organization[]>}
 */
export const getOrganizations = async () => {
  const { data } = await graphqlCall(GRAPHQL_URL, GET_EBS_ORGANIZATIONS);
  return data.getEbsOrganizations;
};
